Postlogin.Lesson = (function (my) {
    my.RateYourInterest = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);
        me.play_pause_enabled = false;
        me.help_enabled = false;

        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let container;

        me.init = function () {
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            if (me.activity_data.question_text) {
                const question = $('<div class="question"></div>');

                if (me.activity_data.question_audio) {
                    question.attr('data-audio', me.activity_data.question_audio);
                }
                question.append($(`<h2 class="question-title">${me.activity_data.question_text}</h2>`));
                segmentContainer.append(question);
            }

            const optionsContainer = $('<div></div>').addClass('options-container');

            // create and add the three emoji options
            const negativeEmoji = $('<div></div>').addClass('item option-negative has-image').attr('data-option-id', 'negative');
            negativeEmoji.append(
                '<div class="wrapper"><span class="emoji sad"><span class="eyes"></span><span class="mouth"></span></span><div class="option-text cartoony"><span>Dislike</span></div></div>',
            );
            optionsContainer.append(negativeEmoji);

            const neutralEmoji = $('<div></div>').addClass('item option-neutral has-image').attr('data-option-id', 'neutral');
            neutralEmoji.append(
                '<div class="wrapper"><span class="emoji neutral"><span class="eyes"></span><span class="mouth"></span></span><div class="option-text cartoony"><span>Unsure</span></div></div>',
            );
            optionsContainer.append(neutralEmoji);

            const positiveEmoji = $('<div></div>').addClass('item option-positive has-image').attr('data-option-id', 'positive');
            positiveEmoji.append(
                '<div class="wrapper"><span class="emoji happy"><span class="eyes"></span><span class="mouth"></span></span><div class="option-text cartoony"><span>Like</span></div></div>',
            );
            optionsContainer.append(positiveEmoji);

            segmentContainer.append(optionsContainer);

            $(segmentContainer).on('click', '.item', function () {
                const selection = $(this).data('option-id');
                // no wrong answers!
                Postlogin.Lesson.playSoundEffect('correct');

                $(this).addClass('selected');
                $(container)
                    .find('.item')
                    .not(this)
                    .each(function () {
                        $(this).addClass('disappear');
                    });

                me.setCompleted();

                // if this is a real lesson and not a preview... save the students response
                if (Postlogin.Lesson.getUserLessonId() != null && Postlogin.Lesson.getUserLessonId() > 0) {
                    // console.log('saving interest');
                    const saveInterestUrl = Slim.Router.urlFor('Lesson.saveInterest', {
                        lesson_id: Postlogin.Lesson.getLessonId(),
                        user_lesson_id: Postlogin.Lesson.getUserLessonId(),
                    });
                    $.post(saveInterestUrl, { interest: selection }, () => {
                        //
                    });
                }

                setTimeout(() => {
                    me.advance();
                }, 750);
            });

            $(container).on('click', '.question', () => {
                me.speakQuestion();
            });

            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        me.replay = function () {
            $(container)
                .find('.item')
                .each(function () {
                    $(this).removeClass('selected disappear');
                });

            me.speakQuestion(0, () => {
                if (me.completed && !me.last) {
                    Postlogin.Lesson.showNextButton();
                }
            });
        };

        me.show = function () {
            me.setup();

            $(container)
                .find('.item')
                .each(function () {
                    $(this).removeClass('selected disappear');
                });

            me.speakQuestion(0, () => {
                if (me.completed && !me.last) {
                    Postlogin.Lesson.showNextButton();
                }
            });
        };

        me.hide = function () {
            me.breakdown();
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
